import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { pushEvent } from '../../utilities/analytics';
import { DEAL_CLICK_EVENT } from '../../constants/analyticEvents';
import { isB2B, isMobile } from '../../utilities/helpers';

// Made for better testing and to keep same logic for different UI.
function useDealClickHandler(dealItem, position, cardTitle, cardTutorial, isDealOfTheDay = false) {
  const userProfile = useSelector(state => state.user.searchProfile);
  const { hotel, offer } = dealItem;
  const { hfOfferId, packageDeeplinkUrl } = offer;

  const saveUserProfile = () => {
    if (!userProfile) return undefined;

    const usersProfileObj = JSON.parse(localStorage.getItem('usersProfileObj')) || {};

    usersProfileObj[hfOfferId] = { ...userProfile, timestamp: Date.now() };

    try {
      localStorage.setItem('usersProfileObj', JSON.stringify(usersProfileObj));
    } catch (error) {
      console.log('Saving search usersProfile to localStorage error:', error);
      localStorage.removeItem('usersProfileObj');
    }
  };

  const handleDealClick = useCallback((e) => {
    // Exclude clicks on popup elements rendered via portal (ensure popups have a "popup-portal" class)
    if (e?.target?.closest('.voyage-dialog__overlay') || e?.target?.closest('.voyage-dialog__content') || e?.target?.closest('.hf-modal-overlay')) {
      return;
    }

    const ignoreElementClasses = [
      'sticker__wrap',
      'sticker',
      'sticker__icon',
      'sticker__text',
      'location-icons-wrap',
      'ri-heart-line',
      'ri-add-line',
      'ri-heart-fill',
      'ri-equalizer-line',
      'photo__button-arrow',
      'ri-arrow-left-s-line',
      'settings__icon-close',
      'ri-eye-line',
      'ri-eye-off-line',
      'settings__button',
      'air-company-logo',
      'heart-body',
      'deal-baggage-icon',
      'deal-price-info',
      'ri-information-line',
      'proposal-dialog',
      'voyage-dialog__content',
      'ri-subtract-line',
      'js_adjust-commission',
    ];

    // Check if the clicked element or any of its parents have the ignored classes
    const hasIgnoredClass = ignoreElementClasses.some(className => {
      return e?.target?.closest(`.${className}`) !== null;
    });

    if (hasIgnoredClass) {
      return undefined;
    }

    const dealItemLog = { ...dealItem, userProfile };
    dealItemLog.favorites = false;
    let isFavForUrl = '';
    if (window.location.href.indexOf('favorites') > -1) {
      dealItemLog.favorites = true;
      isFavForUrl = '&origin=my-favorites';
    }
    dealItemLog.cardPosition = position;
    dealItemLog.cardDesign = 2;
    dealItemLog.cardTitle = cardTitle;
    dealItemLog.locationGrade = hotel.location?.score;
    dealItemLog.hasCardTutorialMessage = cardTutorial;

    saveUserProfile();

    let movsessid = '';
    if (window.location.search.indexOf('movsessid') > -1) {
      // Add movsessid to the offer URL (for analytics)
      const urlParams = new URLSearchParams(window.location.search);
      movsessid = `&movsessid=${urlParams.get('movsessid')}`;
    }

    // Save the last search URL for the back button
    localStorage.setItem('lastSearchUrl', window.location.href);

    // Testing different options for opening page.
    // const targetWindow = isMobile() ? `dealInfo_${format(new Date(), 'dd-MM-yyyy')}` : '_blank';
    let searchParams =  `/?bc=${hfOfferId}${movsessid}/#/`;

    if (isMobile()) {
      window.name = 'searchList';
    }

    const isFlexibleDates = ['flexible-dates-link', 'fdl-1', 'fdl-2'].some((item) => e?.target?.closest(`.${item}`) !== null);
    dealItemLog.isFlexibleDates = isFlexibleDates;
    dealItemLog.isDealOfTheDay = isDealOfTheDay;
    let additionalParams =`&searchProfile=${userProfile?.id || 0}&position=${position}${isFavForUrl}`;
    if (isDealOfTheDay) {
      additionalParams = `&dealOfTheDay=true`;
    }
    if (isFlexibleDates) {
      additionalParams = `&scrollDates=true`;
    }
    if (isB2B() && window.location.href.indexOf('b2bcustomerview') !== -1) {
      additionalParams = `&b2bcustomerview=true`;
    }

    const url = `${packageDeeplinkUrl.replace(
      '/#/',
      searchParams
    )}${additionalParams}`;

    window.open(
      url,
      '_blank'
    );

    // Save current search params for the 'More in ...' buttons
    const offerSearches = JSON.parse(localStorage.getItem('offerSessionTrace')) || {};
    offerSearches[hfOfferId] = {
      moreInParameters: window.location.hash,
      ttl: Date.now(),
    };
    localStorage.setItem('offerSessionTrace', JSON.stringify(offerSearches));
    pushEvent(DEAL_CLICK_EVENT, dealItemLog);
    const time = Date.now();
    if (dealItem?.offer?.hfOfferId) {
      const offerTime = JSON.parse(localStorage.getItem('offerTime')) || {};
      offerTime[dealItem.offer.hfOfferId] = time;
      localStorage.setItem('offerTime', JSON.stringify(offerTime));
    }
  }, [dealItem, position, cardTitle, cardTutorial, userProfile]);

  return handleDealClick;
}

export default useDealClickHandler;
